
import moment from "moment";
import 'moment/locale/en-gb';

require("../vendor/jquery.daterangepicker.js");
require("../../scss/vendor/jquery.daterangepicker.css");

$(document).ready(function(e){
	if ($(document).find('.calculator-container').length > 0){

		var container = $(document).find('.calculator-container');

		var $select = container.find('select.ajax-select');
		var calculatorJSON = {};
		var holidayJSON = {};
		var currentRule,
			currentStartDate = moment(), // Set todays date as default
			outputStartDate = moment(), // Set todays date as default
			debug = false; // Add debugging for quick console.logs

		var Calculators = {

			init: function() {
				Calculators.getCalculatorJSON();
			},

			getCalculatorJSON: function() {
				$.ajax({
					url: container.data('rules_url'),
					dataType: 'json',
					success: function(data) {
						calculatorJSON = data;
						Calculators.appendOptions();
						Calculators.getHolidays();
						Calculators.setupCalendar('.calendar');
						Calculators.bindEventHandlers();
					},
					error: function(data) {
						console.log(data);
					}
				});
			},

			getHolidays: function() {
				$.ajax({
					url: container.data('holidays_url'),
					dataType: 'json',
					success: function(data){
						holidayJSON = data;
					},
					error: function(data){
						console.log(data);
					}
				});
			},

			appendOptions: function() {
				$.each(calculatorJSON, function(i, v){
					$select.append('<option value=' + i + '>' + v.code + " - " + v.short_title + '</option>');
				});
			},

			setupCalendar: function(el, values) {

				// Set up our dateRangePicker plugin on each calendar
				$(el).dateRangePicker({
					inline:true,
					container: $(el),
					alwaysOpen:true,
					singleMonth: false,
					showShortcuts: false,
					showTopbar: false,
					hoveringTooltip: false,
					beforeShowDay: Calculators.checkCalendarDay
				}).bind('datepicker-first-date-selected', function(event, obj){

					// Bind the click event when we select the first date
					// This will automate selecting the date range
					if (currentRule == undefined) {
						Calculators.clearCalendar(); // Clear the calendar if there's no rule selected
					} else {
						currentStartDate = obj;
						Calculators.setNewDate($(el), obj, currentRule, values);
					}
				});
			},

			checkCalendarDay: function(date){

				// I'm a holiday
				if (typeof(holidayJSON[moment(date).format("YYYY-MM-DD")]) !== 'undefined'){
					return [true, 'holiday'];

				// I'm a weekend
				} else if (moment(date).day() == 0 || moment(date).day() == 6){
					return [true, 'weekend'];

				// I'm just a regular old business day
				} else {
					return [true,''];
				}
			},

			checkWeekends: function(startDate, finishDate, currentRule, values) {
				// Check to see if our end date falls on a weekend
				// 0 = Sunday, 6 = Saturday

				if (debug) {
					console.log("End date - " + finishDate.format("dddd"));
				}

				if (finishDate.day() == 6) {
					// If the date lands on a Saturday we need to add 2 days
					// Setting the date to Monday falls back a week otherwise
					if (currentRule.rule.direction == "reverse" || values && values.direction == "reverse") {
						finishDate = finishDate.subtract(1, 'days');
					} else {
						finishDate = finishDate.add(2, 'days');
					}
				} else if (finishDate.day() == 0) {
					if (currentRule.rule.direction == "reverse" || values && values.direction == "reverse") {
						finishDate = finishDate.subtract(2, 'days');
					} else {
						finishDate = finishDate.add(1, 'days');
					}
				}

				return finishDate;
			},

			checkHolidays: function(startDate, finishDate, currentRule, values) {
				var holidays = holidayJSON;

				// Check each holiday to see if our object matches
				$.each(holidays, function(i, v) {
					if (moment(v.Date).format("YYYY-MM-DD") == finishDate.format("YYYY-MM-DD")) {

						if (debug) {
							console.log("End date has fallen on a holiday - " + v.Date);
						}
						// If the object matches a holiday add a day
						if (currentRule.rule.direction == "reverse" || values && values.direction == "reverse") {
							finishDate = finishDate.subtract(1, 'days');
						} else {
							finishDate = finishDate.add(1, 'days');
						}
						// Check again for a holiday on our new end date
						Calculators.checkHolidays(finishDate, currentRule, values);
					}
				});
				return finishDate;
			},

			setNewDate: function(calendar, obj, currentRule, values) {

				var startDate = moment(obj.date1);
				var finishDate;

				if (debug) {
					console.log('setNewDate()');
					console.log(calendar, obj, currentRule, values);
					console.log('---');
				}

				// Check to see if we have one input and need to show multiple output calendars
				if (currentRule.rule.outputs && calendar.hasClass("output-calendar")) {
					// Loop through each output
					$.each(currentRule.rule.outputs, function(i, v){
						// Get the endDate for each output based on the values
						var outputFinish = Calculators.getFinishDate(startDate, currentRule, v);
						var outputCalendar = $('.output-calendar' + i);
						// Get each of our calendars and display the dateRange
						outputCalendar.data('dateRangePicker').setDateRange(startDate.format("YYYY-MM-DD"), outputFinish.format("YYYY-MM-DD"), true);
						outputCalendar.parent().show();
						outputCalendar.find('.gap').css('height', 'auto');

						// Update the labels
						Calculators.updateDateLabels(outputCalendar, startDate, outputFinish, v.result);
						// and show our hidden calendars on the screen
					});
					return;
				}

				// Otherwise each input has one output
				// Make sure we have a rule loaded
				if (currentRule) {
					// Calculate our finish date
					finishDate = Calculators.getFinishDate(startDate, currentRule, values);
					// Set and display our date range
					if (calendar.length) {
						calendar.data('dateRangePicker').setDateRange(startDate.format("YYYY-MM-DD"), finishDate.format("YYYY-MM-DD"), true);
					}

					// Update the labels to display our dates
					if (values) {
						Calculators.updateDateLabels(calendar, startDate, finishDate, values.result);
					} else {
						Calculators.updateDateLabels(calendar, startDate, finishDate, currentRule.rule.result);
					}
				}
			},

			getFinishDate: function(startDate, currentRule, values) {
				var number_of_days = 0;
				var direction = 1;

				if(debug) {
					console.log('getFinishDate()');
					console.log(startDate, currentRule, values);
					console.log('---');
				}

				// Make sure we have a rule loaded
				if (currentRule) {
					number_of_days = Calculators.getNumberOfDays(currentRule, values);

					// Check what direction we are going in and add or subtract days based on this
					if (currentRule.rule.direction == "reverse") {
						//finishDate = moment(startDate).subtract(numberOfDays, 'days');
						direction = -1;
					} else if (values && values.direction == "reverse") {
						//finishDate = moment(startDate).subtract(numberOfDays, 'days');
						direction = -1;
					} else {
						//finishDate = moment(startDate).add(numberOfDays, 'days');
					}

					//finishDate = Calculators.checkWeekends(startDate, finishDate, currentRule, values);
					//finishDate = Calculators.checkHolidays(startDate, finishDate, currentRule, values);
				}


				/**
				 * Figure out how many days we need to recover (pad)
				 * This accounts for weekends and holidays that fall between our start and end dates
				 **/

				var days_to_add = 0;
				var days_to_check = number_of_days;

				// Start one day from now. The selected date (startDate) does not count towards
				// the days counter
				var day_in_focus = moment(startDate).add(direction, 'days');

				// Rinse and repeat until we've got no more days to check
				while (days_to_check > 0){

					// This is a holiday
					if (typeof(holidayJSON[day_in_focus.format('YYYY-MM-DD')]) !== 'undefined'){

						// Add one more day to our checker
						days_to_check++;

					// This is a weekend
					} else if (day_in_focus.day() == 0 || day_in_focus.day() == 6){

						// Add one more day to our checker
						days_to_check++;
					}

					// Move to the next day
					days_to_check--;
					days_to_add++;
					day_in_focus.add(direction, 'days');
				}

				// Calculate our finish date
				var finishDate = moment(startDate);
				finishDate.add(days_to_add * direction, 'days');

				return finishDate;
			},

			getNumberOfDays: function(currentRule, values) {
				if (currentRule.rule.period) {
					var days = currentRule.rule.period;
				} else if (values && values.period) {
					var days = values.period;
				}

				return parseInt(days);
			},

			updateDateLabels: function(calendar, startDate, endDate, result = ""){

				var start_date = startDate.format('dddd')+', '+startDate.format('D MMMM YYYY');
				var end_date = endDate.format('dddd')+', '+endDate.format('D MMMM YYYY');

				result = result.replace('$StartDate', '<span class="rule-key-date rule-key-date-start">'+start_date+'</span>');
				result = result.replace('$EndDate', '<span class="rule-key-date rule-key-date-end">'+end_date+'</span>');

				calendar.parent().find('.rule-key-dates').show().html(result);
			},

			clearCalendar: function() {
				// Clear our canvas
				$('.rule-message').html("");
				$('.calendar').data('dateRangePicker').clear();
				$('.rule-key-dates').hide();
				$('.rule-bottom-message').hide();
				currentRule = null;
			},

			setupMultiCalendar: function(json) {
				// Destory our previous calendars
				Calculators.destroyMultiCalendar();
				// Hide the first calendar as we are creating new ones
				$('.rule-calendar .calendar').hide();
				$('.rule-calendar .rule-key-dates').hide();

				var i = 0;
				if (json.rule.inputs) {
					// Loop through each of our inputs
					$.each(json.rule.inputs, function(index,v){
						// Build out our HTML
						$('.rule-calendar').append('<div class="multi-cal multi-cal' + i + '" data-direction="'+v.direction+'"><div class="calendar' + i + '"></div></div>');
						// Create a clone of the rule wordings and append to each new calendar
						var clone = $('.rule-key-dates').first().clone(true);
						$('.multi-cal' + i).append(clone);

						var messageClone = $('.rule-bottom-message').first().clone(true);
						$('.multi-cal' + i).append(messageClone);
						// Setup our new calendars to use the dateRangePicker
						Calculators.setupCalendar(".calendar" + i, v);
						Calculators.setCalendarInputText(".calendar" + i, v.inputMessage);
						Calculators.setCalendarBottomText(".calendar" + i, v.bottomMessage);
						++i;
					});
				}

				if (json.rule.outputs) {
					// Loop through each of our outputs
					$.each(json.rule.outputs, function(index,v){
						// Build out our HTML
						$('.rule-calendar').append('<div class="multi-cal multi-cal' + i + '" data-direction="'+v.direction+'"><div class="calendar' + i + ' output-calendar output-calendar'+ index +'"></div></div>');
						// Create a clone of the rule wordings and append to each new calendar
						var clone = $('.rule-key-dates').first().clone(true);
						$('.multi-cal' + i).append(clone);

						var messageClone = $('.rule-bottom-message').first().clone(true);
						$('.multi-cal' + i).append(messageClone);

						// Setup our new calendars to use the dateRangePicker
						Calculators.setupCalendar(".calendar" + i, v);
						Calculators.setCalendarInputText(".calendar" + i, v.inputMessage);
						Calculators.setCalendarBottomText(".calendar" + i, v.bottomMessage);
						++i;
					});

					$('.output-calendar').not('.output-calendar0').parent().hide();
				}
			},

			setCalendarInputText: function(calendar, inputMessage) {
				if(typeof inputMessage !== "undefined") {
					$(calendar).prepend("<h3 class='rule-label rule-input-message'>Select date <span>"+ inputMessage + "</span></h3>");
				}
			},

			setCalendarBottomText: function(calendar, bottomMessage) {
				if(typeof bottomMessage !== "undefined") {
					$(calendar).parent().find('.rule-bottom-message').html("Please note: <span>"+ bottomMessage + "</span>");
				}
			},

			destroyCalendarInputText: function(calendar, inputMessage) {
				$(".rule-input-message").remove();
			},

			destroyMultiCalendar: function() {
				$('.multi-cal').remove(); // Remove our multi calendars
				currentStartDate = moment(); // Set the currentStartDate to todays date
				$('.calendar').show(); // re-display our single calendar
			},

			bindEventHandlers: function() {
				$(document).on('change', 'select.ajax-select', function(){
						
					$('.rule-notice').hide();
					
					// Check we're not selecting our default value
					if (this.value == "" || undefined) {
						Calculators.clearCalendar();
						container.find('.calculator-body').hide();
					} else {
						container.find('.calculator-body').show();
						currentRule = calculatorJSON[this.value];
						$('.calendar').css("display", 'block');
						$('.rule-key-dates').css("display", 'block');
						$('.rule-bottom-message').css("display", 'block');
						Calculators.destroyCalendarInputText();

						// Get the current rule from the JSON
						if (currentRule.rule.popupMessage) {
							Calculators.destroyCalendarInputText();
							$('.calendar').css("display", 'none');
							$('.rule-key-dates').css("display", 'none');
							$('.rule-bottom-message').css("display", 'none');

							$('.rule-notice-title').html(currentRule.code + " - " + currentRule.short_title);
							$(".rule-notice-message").text(currentRule.rule.popupMessage);
							$('.rule-notice').show();

						} else if (currentRule.rule.inputs || currentRule.rule.outputs) {
							// We have multiple start dates so remove the currentStartDate
							currentStartDate = undefined;
							// And now initialize our multiple calendars
							Calculators.setupMultiCalendar(currentRule);

						} else {
							// If we're just displaying a single calendar, destory all the multis
							Calculators.destroyMultiCalendar();
							// Set up our new date for individual inputs/outputs
							if (currentStartDate != undefined) {
								Calculators.setCalendarInputText(".calendar", currentRule.rule.inputMessage);
								Calculators.setCalendarBottomText(".calendar", currentRule.rule.bottomMessage);
								Calculators.setNewDate($('.calendar'), currentStartDate, currentRule);
							}

							// Append our direction to the DOM
							$('.calendar').attr('data-direction', currentRule.rule.direction);
						}

						// Display the rule message next to the dropdown
						$('.rule-message').html(currentRule.rule.message);
					}
				});
			}
		}

		Calculators.init();
	}
});


// WEBPACK FOOTER //
// ./app/js/components/calculator.js